import { Component, Input } from '@angular/core';
import { ElementDefinitionDocumentModel, ElementDocumentModel, ElementModel, Form, FormElement, TranslationManager, ViewState } from 'src/common';
import { ElementMode, ElementOrderDirection, ElementViewModel } from '../elements.model';

@Component({
  selector: 'element-document',
  templateUrl: './element-document.component.html'
})
export class ElementDocumentComponent {

  @Input() mode: ElementMode = ElementMode.Definition;
  elementMode = ElementMode;
  @Input() state: ViewState;
  @Input() showOrderUp: boolean;
  @Input() showOrderDown: boolean;
  viewState = ViewState;
  form: Form = new Form();
  formValue: Form = new Form();
  translationManager = TranslationManager;
  private _element: ElementViewModel;
  elementOrderDirection = ElementOrderDirection;

  @Input() set element(value: ElementViewModel) {
    this._element = value;
    this._element.isValid = this.isValid.bind(this);
    this._element.isValueValid = this.isValueValid.bind(this);
    this._element.getElement = this.getElement.bind(this);
    this._element.getValue = this.getValue.bind(this);
    this.mapElementToForm();
    this.refreshFormState();
  }

  constructor() {
    this.initForm();
  }

  isValid(): boolean {
    return this.form.isValid();
  }

  isValueValid(): boolean {
    return this.formValue.isValid();
  }

  getValue(): any {
    return this.formValue.elements['value'].value;
  }

  getElement(): ElementModel {
    this.mapFormToElement();
    return this._element.element;
  }

  private initForm() {
    this.form.elements['name'] = new FormElement();
    this.form.elements['isMandatory'] = new FormElement();
    this.form.elements['description'] = new FormElement();
    this.form.elements['isDocumentMandatory'] = new FormElement();
    this.formValue.elements['value'] = new FormElement();
  }

  private mapElementToForm() {
    let model: ElementDocumentModel = this._element.element.data as ElementDocumentModel;

    this.form.elements['name'].value = model.name;
    this.form.elements['isMandatory'].value = model.isMandatory;

    if (model.definition) {
      this.form.elements['description'].value = model.definition.description;
      this.form.elements['isDocumentMandatory'].value = model.definition.isDocumentMandatory;
    }
  }

  private refreshFormState() {
    this.form.elements['name'].state.mandatory = this.mode == ElementMode.Definition;
    this.formValue.elements['value'].state.mandatory = this.form.elements['isMandatory'].value;
  }

  private mapFormToElement() {
    let model: ElementDocumentModel = this._element.element.data as ElementDocumentModel;

    model.name = this.form.elements['name'].value;
    model.isMandatory = this.form.elements['isMandatory'].value;

    if (!model.definition) {
      model.definition = new ElementDefinitionDocumentModel();
    }

    model.definition.description = this.form.elements['description'].value;
    model.definition.isDocumentMandatory = this.form.elements['isDocumentMandatory'].value;
  }

  delete() {
    this._element.delete(this._element);
  }
}
